import { IEnergy } from '../model/ICheckin';
import { MouseEvent } from 'react';

export interface IEnergyToggleProps {
    energy: IEnergy;
    selected: boolean;
    disabled: boolean;
    onClick: () => Promise<void>;
}

export const EnergyToggle: React.FC<IEnergyToggleProps> = ({ energy, selected, disabled, onClick }) => {

    // e.g. "/assets/images/energy/battery-50-inactive.svg"
    const imageUrl = `/assets/images/energy/battery-${energy}-${selected ? 'active' : 'inactive'}.svg`;

    const handleClick = async (e: MouseEvent) => {
        e.stopPropagation();
        await onClick();
    };

    return (
        <div
            onClick={handleClick}
            data-id={`energy-${energy}`}
            data-type={`${selected ? 'active' : 'inactive'}`}
            style={{cursor:'pointer', opacity: disabled ? 0.5 : 1}}
        >
            <img src={imageUrl} alt="" />
        </div>
    );
};
